import { CONTACT_FORM_FIELDS } from '../validation/fields.js';

/**
 * Fields of the records kept by the portal (brief section 3) that the
 * devices may change through the sync API. Everything else (created_by,
 * timestamps, HubSpot state) is set by the server only.
 */
export const CONTACT_FIELDS = [
  ...CONTACT_FORM_FIELDS,
  'event_id',
  'source',
  'needs_verification',
  'consent_at',
  'consent_text_version',
  // Booth kiosk (step 6): what the visitor asked to receive, in which language.
  'kiosk_asset_ids',
  'kiosk_lang',
] as const;
export type ContactField = (typeof CONTACT_FIELDS)[number];

/**
 * A lead: the four creation answers, company, deal, Discovery Capture.
 * Interest stays accepted (leads created before Nov 2, 2026, and changes
 * still waiting on a device), but no screen asks it any more.
 */
export const LEAD_FIELDS = [
  'interest',
  'role',
  'pain',
  'applications',
  'country',
  'company_name',
  'company_hubspot_id',
  'event_id',
  'deal_name',
  'installation_country',
  'owner_user_id',
  'stage_id',
  'deal_market',
  'product_fit',
  'qualification',
  'disqualified_why',
  'disqualified_when',
  'project_call_date',
  'note',
  'where_from',
] as const;
export type LeadField = (typeof LEAD_FIELDS)[number];

/** Changing these needs the permission leads.qualify. */
export const LEAD_QUALIFICATION_FIELDS = [
  'qualification',
  'product_fit',
  'disqualified_why',
  'disqualified_when',
] as const satisfies readonly LeadField[];

/** An edition of a show; its event ID (SERIES-YEAR) is computed by the server. */
export const EVENT_FIELDS = [
  'series',
  'year',
  'location',
  'starts_on',
  'ends_on',
  'status',
] as const;
export type EventField = (typeof EVENT_FIELDS)[number];

/** A note shared with everyone on the event (brief section 5). */
/** done: checked off by anyone on the event (step 6). */
export const EVENT_NOTE_FIELDS = ['event_id', 'text', 'day', 'time', 'done'] as const;
export type EventNoteField = (typeof EVENT_NOTE_FIELDS)[number];

export const EVENT_STATUSES = ['active', 'completed'] as const;
export const QUALIFICATIONS = ['qualified', 'disqualified'] as const;
export const WHERE_FROM = ['Tradeshow', 'Email'] as const;

/** A receipt (brief sections 3 and 7.8); its reference and sending are the server's. */
export const EXPENSE_FIELDS = [
  'vendor',
  'spent_on',
  'currency',
  'total',
  'tax_gst',
  'tax_qst',
  'tax_vat',
  'budget_line',
  'event_id',
  'client',
  'purpose',
  'guests',
  /** A photo of the receipt follows (camera or file); false when entered manually. */
  'receipt_expected',
] as const;
export type ExpenseField = (typeof EXPENSE_FIELDS)[number];
